import './bootstrap'
import VueApexCharts from "vue3-apexcharts";
import axios from 'axios';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import './assets/css/custom.css'
import Multiselect from "vue-multiselect";
import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import { useAuthStore } from "./store/auth";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import SideNavBar from "@/components/system/SideNavBar.vue";
// import { Combobox } from "@/shadcn/components/ui/combobox";

const EditEnterpriseMarket = defineAsyncComponent(() => import('./components/v4/enterprise/markets/Edit.vue'));
const ShowEnterpriseMarketDetails = defineAsyncComponent(() => import('./components/v4/enterprise/markets/Show.vue'));
const CreateEnterpriseMarket = defineAsyncComponent(() => import('./components/v4/enterprise/markets/Create.vue'));
const EnterpriseMarkets = defineAsyncComponent(() => import('./components/v4/enterprise/markets/Index.vue'));
const EnterpriseProfile = defineAsyncComponent(() => import('./components/v4/market/profile/Index.vue'));
const ReferralCode = defineAsyncComponent(() => import('./components/v4/member/compliance/ReferralCodeCompliance.vue'));
const WalletIndex = defineAsyncComponent(() => import('./components/v4/member/wallet/index.vue'));
const WalletTransfer = defineAsyncComponent(() => import('./components/v4/member/wallet/transfer/Index.vue'));
const PaymentIndex = defineAsyncComponent(() => import('./components/order/payment/Index.vue'));
const CreateFees = defineAsyncComponent(() => import('./components/v4/market/fee/Create.vue'));
const CreateCharge = defineAsyncComponent(() => import('./components/v4/market/fee/CreateCharge.vue'));
const DeleteChargeFee = defineAsyncComponent(() => import('./components/v4/market/fee/DeleteChargeFee.vue'));
const ReceivePayment = defineAsyncComponent(() => import('./components/order/payment/ReceivePayment.vue'));
const PayFeesIndex = defineAsyncComponent(() => import('./components/v4/member/pay_fee/Index.vue'));
const ManageMarkketFees = defineAsyncComponent(() => import('./components/v4/market/fee/ManageFees.vue'));
const MarketMemberFeeList = defineAsyncComponent(() => import('./components/v4/enterprise/fees/MarketMemberFeeList.vue'));
const PayFeesShow = defineAsyncComponent(() => import('./components/v4/member/pay_fee/Show.vue'));
const VerificationIcons = defineAsyncComponent(() => import('./components/reusables/icons/UserIcons.vue'));
const RBACIndex = defineAsyncComponent(() => import('./components/v4/admin/rbac/RBACIndex.vue'));
const AddUser = defineAsyncComponent(() => import('./components/v4/admin/rbac/AddUser.vue'));
const ComplianceIndex = defineAsyncComponent(() => import('./components/v4/admin/communication/compliance/ComplianceIndex.vue'));
const MarketComplianceFinance = defineAsyncComponent(() => import('./components/v4/admin/finance/compliance/MarketComplianceFinance.vue'));
const FinanceUserCompliance = defineAsyncComponent(() => import('./components/v4/admin/finance/compliance/FinanceUserCompliance.vue'));
const CameraCapture = defineAsyncComponent(() => import('./components/camera/CameraCapture.vue'));
const PayForOrder = defineAsyncComponent(() => import('./components/order/PayForOrder.vue'));
const UpcomingPayments = defineAsyncComponent(() => import('./components/v4/member/dashboard/UpcomingPayments.vue'));
const AcceptOrder = defineAsyncComponent(() => import('./components/order/AcceptOrder.vue'));
const MemberVerification = defineAsyncComponent(() => import('./components/v4/member/compliance/Index.vue'));
const LoginPage = defineAsyncComponent(() => import('./components/v4/signin/LoginPage.vue'));
const MarketChanger = defineAsyncComponent(() => import('./components/system/MarketChanger.vue'));
const FinanceSettings = defineAsyncComponent(() => import('./components/v4/admin/finance/settings/Index.vue'));
const MemberManagement = defineAsyncComponent(() => import('./components/v4/market/members/MemberManagement.vue'));
const TeamManagement = defineAsyncComponent(() => import('./components/v4/market/members/teams/TeamManagement.vue'));
const ProfilePage = defineAsyncComponent(() => import('./components/v4/member/profile/ProfilePage.vue'));
const UserAvatar = defineAsyncComponent(() => import('./components/reusables/avatar/UserAvatar.vue'));
const UserNotifications = defineAsyncComponent(() => import('./components/notifications/UserNotifications.vue'));
const SummaryCards = defineAsyncComponent(() => import('./components/v4/admin/finance/loan_book/SummaryCards.vue'));
const BankAccount = defineAsyncComponent(() => import('./components/v4/admin/finance/bank_account/BankAccount.vue'));
const AddBankAccount = defineAsyncComponent(() => import('./components/v4/admin/finance/bank_account/AddBankAccount.vue'));
const UpdateBankAccountInfo = defineAsyncComponent(() => import('./components/v4/member/profile/bank/UpdateBankAccountInfo.vue'));
const AddUserBankAccount = defineAsyncComponent(() => import('./components/v4/member/profile/bank/AddBankAccount.vue'));
const BankTransaction = defineAsyncComponent(() => import('./components/v4/admin/finance/bank_account/BankTransaction.vue'));
const CreateMarketMember = defineAsyncComponent(() => import('./components/v4/admin/staff/market/CreateMarketMember.vue'));
const WithdrawalRequest = defineAsyncComponent(() => import('./components/v4/admin/finance/withdrawal_request/WithdrawalRequest.vue'));
const FeeAndCharge = defineAsyncComponent(() => import('./components/v4/market/fee/FeeAndCharge.vue'));
const MarketCharge = defineAsyncComponent(() => import('./components/v4/market/fee/MarketCharge.vue'));
const EnterpriseFeeManagement = defineAsyncComponent(() => import('./components/v4/enterprise/fees/ManageFees.vue'));
const FeeDetail = defineAsyncComponent(() => import('./components/v4/market/fee/FeeDetail.vue'));
const ChargeDetail = defineAsyncComponent(() => import('./components/v4/market/fee/ChargeDetail.vue'));
const FeeChargeCashout = defineAsyncComponent(() => import('./components/v4/market/fee/FeeChargeCashout.vue'));
const NewOrder = defineAsyncComponent(() => import('./components/v4/admin/finance/orders/NewOrder.vue'));
const UserAdministration = defineAsyncComponent(() => import('./components/v4/admin/user/UserAdministration.vue'));
const OrderPayouts = defineAsyncComponent(() => import('./components/v4/admin/finance/payouts/Index.vue'));
const Transaction = defineAsyncComponent(() => import('./components/v4/member/transaction/Transaction.vue'));
const Subscription = defineAsyncComponent(() => import('./components/v4/admin/finance/subscriptions/Subscription.vue'));
const StaffAccess = defineAsyncComponent(() => import('./components/v4/admin/staff/marketaccess/index.vue'));
const Insurance = defineAsyncComponent(() => import('./components/v4/admin/finance/insurance/index.vue'));
const MarketComplianceIndex = defineAsyncComponent(() => import('./components/v4/admin/finance/verifications/markets/Index.vue'));
const MarketComplianceShow = defineAsyncComponent(() => import('./components/v4/admin/finance/verifications/markets/Show.vue'));
const Product = defineAsyncComponent(() => import('./components/v4/market/product/Product.vue'));
const ReportIncidence = defineAsyncComponent(() => import('./components/order/insurance/ReportIncidence.vue'));
const TransactionStatus = defineAsyncComponent(() => import('./components/v4/admin/finance/payouts/TransactionStatus.vue'));
const Earning = defineAsyncComponent(() => import('./components/v4/member/transaction/Earning.vue'));
const PosApplication = defineAsyncComponent(() => import('./components/v4/admin/finance/pos_application/PosApplication.vue'));
const LinkMpesaPayments = defineAsyncComponent(() => import('./components/v4/admin/staff/mpesa/LinkMpesaPayments.vue'));
const FinanceOrder = defineAsyncComponent(() => import('./components/v4/admin/finance/orders/FinanceOrder.vue'));
const AdminNotifications = defineAsyncComponent(() => import('./components/notifications/AdminNotifications.vue'));
const WholesalerVerificationDocuments = defineAsyncComponent(() => import('./components/v4/member/verification/wholesaler/WholesalerVerificationDocuments.vue'));
const IdVerification = defineAsyncComponent(() => import('./components/v4/admin/finance/verifications/id/IdVerification.vue'));
const AddIdVerification = defineAsyncComponent(() => import('./components/v4/admin/finance/verifications/id/AddIdVerification.vue'));
const AddNewMember = defineAsyncComponent(() => import('./components/v4/market/members/create/index.vue'));
const CallToTransactIndex = defineAsyncComponent(() => import('./components/v4/admin/communication/call-to-transact/Index.vue'));
const RiskOutreachIndex = defineAsyncComponent(() => import('./components/v4/admin/communication/risk-outreach/Index.vue'));
const MarketLeadsIndex = defineAsyncComponent(() => import('./components/v4/market/leads/Index.vue'));
const CCVerificationIndex = defineAsyncComponent(() => import('./components/v4/admin/communication/Call-center-verification/Index.vue'));
const AccessDenied = defineAsyncComponent(() => import('./components/reusables/AccessDenied.vue'));
const AuditLogIndex = defineAsyncComponent(() => import('./components/v4/admin/staff/auditlog/Index.vue'));
const CreditQueue = defineAsyncComponent(() => import('./components/v4/admin/finance/credit_queue/Index.vue'));
const RetailerVerificationDocuments = defineAsyncComponent(() => import('./components/v4/member/verification/retailer/RetailerVerificationDocuments.vue'));
const Dashboard = defineAsyncComponent(
    () => import("./components/v4/admin/dashboard/Index.vue"),
);
const MarketCapacity = defineAsyncComponent(() => import('./components/v4/admin/markets/market_capacity/Index.vue'));
const pinia = createPinia()
const app = createApp({});

app.use(pinia)

window.axios = axios;
app.component('insurance', Insurance);
app.component('link-mpesa-orders', LinkMpesaPayments);
app.component('reportincidence', ReportIncidence);
app.component('VueDatePicker', VueDatePicker);
app.component('MultiSelect', Multiselect);
app.component('updatebankaccount', AddUserBankAccount);

// Wallet
app.component('top-up-wallet', WalletIndex);
app.component('wallet-transfer', WalletTransfer);
app.component('make-wallet-payment', PaymentIndex);

// fees_rent_and_taxes
app.component('create-fees', CreateFees);
app.component('create-charge', CreateCharge);
app.component('delete-charge-fee', DeleteChargeFee);
app.component('fee-detail', FeeDetail);
app.component('charge-detail', ChargeDetail);
app.component('fee-charge', FeeAndCharge);
app.component('market-charge', MarketCharge);
app.component('enterprise-fee-management', EnterpriseFeeManagement);
app.component('fee-charge-cashout', FeeChargeCashout);

app.component('payments-index', ReceivePayment);
app.component('pay-fees-index', PayFeesIndex);
app.component('pay-fees-show', PayFeesShow);
app.component('market-fee-management', ManageMarkketFees);
app.component('market-member-fee-list', MarketMemberFeeList);




app.component('loan-book-summary-cards', SummaryCards);

app.component('rbac-add-admin', AddUser);

app.component('compliance-index', ComplianceIndex);
app.component('market-compliance-finance-index', MarketComplianceFinance);
app.component('finance-user-compliance', FinanceUserCompliance);

app.component('camera-capture', CameraCapture);
app.component('payfororder', PayForOrder);
app.component('acceptorder', AcceptOrder);

app.component('memberverification', MemberVerification);
app.component('LoginPage', LoginPage);
app.component('market-changer', MarketChanger);
app.component('upcoming-payments-page', UpcomingPayments);
app.component('create-market-member', CreateMarketMember);
app.component('finance-settings', FinanceSettings);

app.component('rbac-index', RBACIndex);
app.component('member-management', MemberManagement);
app.component('team-management', TeamManagement);

/*Profile page*/
app.component('my-profile-management', ProfilePage);
app.component('user-avatar', UserAvatar);
app.component('notifications', UserNotifications);


app.component('verificationicon', VerificationIcons);
app.component('referralcode', ReferralCode);
app.component('bank-account', BankAccount);
app.component('add-bank-account', AddBankAccount);
app.component('bank-transaction', BankTransaction);

app.component('update-bank-account-info', UpdateBankAccountInfo);

app.component('withdrawal-request', WithdrawalRequest);
app.component('create-order-by-staff', NewOrder);
app.component('user-administration', UserAdministration);
app.component('order-payouts', OrderPayouts);
app.component('member-transactions', Transaction);
app.component('subscription', Subscription);
app.component('staffmarketaccess', StaffAccess);
app.component('pos-application', PosApplication)
app.component('finance-order', FinanceOrder);

app.component('product', Product);
app.component('transactionstatuske', TransactionStatus);

app.component('member-earning', Earning);
app.component('admin-notifications', AdminNotifications);

app.component('wholesaler-verification-documents', WholesalerVerificationDocuments)

app.component('retailer-verification-documents', RetailerVerificationDocuments)


app.component('market-compliance-index', MarketComplianceIndex)
app.component('market-compliance-show', MarketComplianceShow)

app.component('id-verification', IdVerification);
app.component('add-id-verification', AddIdVerification);

app.component('add-new-member', AddNewMember);

app.component('enterprise-profile', EnterpriseProfile);
app.component('enterprise-markets', EnterpriseMarkets);
app.component('create-enterprise-market', CreateEnterpriseMarket);
app.component('show-enterprise-market-details', ShowEnterpriseMarketDetails);
app.component('edit-enterprise-market', EditEnterpriseMarket);

app.component('call-to-transact-index', CallToTransactIndex);
app.component('risk-outreach-index', RiskOutreachIndex);
app.component('market-leads-index', MarketLeadsIndex);
app.component('call-center-verification', CCVerificationIndex);

app.component('credit-queue', CreditQueue);

app.component('access-denied', AccessDenied);

app.component('auditlog-index', AuditLogIndex)

app.component('side-nav-bar', SideNavBar)

app.component("v-select", VueSelect)

app.component('combobox', defineAsyncComponent(() => import('./shadcn/components/ui/combobox/Combobox.vue')))
app.component('generic-dialog', defineAsyncComponent(() => import('./shadcn/components/ui/dialog/GenericDialog.vue')))
app.component('generic-tooltip', defineAsyncComponent(() => import('./shadcn/components/ui/tooltip/GenericTooltip.vue')))
app.component('generic-card', defineAsyncComponent(() => import('./shadcn/components/ui/card/GenericCard.vue')))
app.component('generic-button', defineAsyncComponent(() => import('./shadcn/components/ui/button/Button.vue')))
app.component('generic-input', defineAsyncComponent(() => import('./shadcn/components/ui/input/GenericInput.vue')))
app.component('generic-input-group', defineAsyncComponent(() => import('./shadcn/components/ui/input-group/GenericInputGroup.vue')))
app.component('shadcn-accordion', defineAsyncComponent(() => import('./shadcn/components/ui/accordion/ShadcnAccordion.vue')))
app.component('generic-breadcrumb', defineAsyncComponent(() => import('./shadcn/components/ui/breadcrumb/GenericBreadcrumb.vue')))
app.component('nested-page-breadcrumb', defineAsyncComponent(() => import('./shadcn/components/ui/breadcrumb/NestedPageBreadcrumb.vue')))

app.component("dashboard", Dashboard);
app.component("market-capacity", MarketCapacity);
const i18n = createI18n({
    locale: 'en',
    allowComposition: true,
})

app.use(i18n)
// app.use(plugin, defaultConfig)
app.use(VueApexCharts);
const user = useAuthStore();
user.updateUserDetails();

app.config.productionTip = false;

app.mount('#app')
